export default __webpack_public_path__ + "static/media/Mask Group 138.eae79e4a.svg";